import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=274bfbe2&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=274bfbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bfbe2",
  null
  
)

export default component.exports